import React, { useState } from 'react';
import styles from './ImageWithButtons.module.scss';
import GrtButton from '../../../../components/Web/GrtButton';
import AipptaiLogo from '../../../../assets/images/web/AipptaiLogo.png';
import errImg from '@/assets/images/usual/errImg.png';

const ImageWithButtons = ({
    imageUrl = '/favicon.ico', // 默认图片
    imageAlt = '示例图片',
    buttonText1 = '编辑',
    buttonText2 = '下载',
    onButton1Click,
    onButton2Click,
    className = '',
    imageStyle = {},
    disabled = false,
    pptId // 🔥 新增：接收PPT ID属性
}) => {
    const handleButton1Click = () => {
        if (!disabled && onButton1Click) {
            onButton1Click();
        }
    };

    const handleButton2Click = () => {
        if (!disabled && onButton2Click) {
            onButton2Click();
        }
    };

    // 处理图片加载失败
    const handleImageError = (e) => {
        if (e.target.src !== errImg) {
            e.target.src = errImg;
        }
    };

    return (
        <div className={`${styles.container} ${className}`}>
            {/* 图片区域 */}
            <div className={styles.imageContainer}>
                <img
                    src={imageUrl}
                    alt={imageAlt}
                    className={styles.image}
                    onError={handleImageError}
                />
            </div>

            {/* AI标识 - 在图片下方 */}
            <div className={styles.aiLabel}>
                <img
                    src={AipptaiLogo}
                    alt="AI生成"
                    className={styles.aiLogo}
                />
            </div>

            {/* 按钮区域 - 在图片容器外面的右下角 */}
            <div className={styles.buttonContainer}>
                <GrtButton
                    className={styles.editButton}
                    onClick={handleButton1Click}
                    disabled={disabled}
                    size="small"
                    style={{
                        width: '52px',
                        height: '28px',
                        borderRadius: '6px',
                        fontSize: '14px',
                        padding: 0
                    }}
                >
                    {buttonText1}
                </GrtButton>

                <GrtButton
                    className={styles.downloadButton}
                    onClick={handleButton2Click}
                    disabled={disabled}
                    type="primary"
                    size="small"
                    style={{
                        width: '52px',
                        height: '28px',
                        borderRadius: '6px',
                        fontSize: '14px',
                        padding: 0
                    }}
                >
                    {buttonText2}
                </GrtButton>
            </div>
        </div>
    );
};

// 🔥 新增：设置displayName，便于调试和组件类型检查
ImageWithButtons.displayName = 'ImageWithButtons';

export default ImageWithButtons; 